module.exports = __webpack_public_path__ + "static/img/3.0fb2c9bd.jpg";